import { StateStream } from '@cgs/wge';

export const BUY_FEATURE_POPUP_COMPONENT_TOKEN = Symbol('BUY_FEATURE_POPUP_COMPONENT_TOKEN');

export abstract class BuyFeaturePopupComponent {
  public readonly isShown: StateStream<boolean> = new StateStream(false);
  public abstract show(): void;
  public abstract hide(): void;
}
